import React, { memo } from 'react';
import { useIntl } from 'react-intl';
import type { CellProps } from 'react-table';

import Account from '@swf/core/assets/icons//alternates/account.svg';
import type { Tournament } from '@swf/poker';

import styles from '../shared.scss';

import TableCellBase from './TableCellBase';

type Props = CellProps<Tournament> & { showIcon?: boolean };

const TableCellPlayers: React.FC<Props> = memo((props) => {
  const { row, showIcon } = props;
  const { formatNumber } = useIntl();

  const displayValue = (
    <>
      {showIcon && <Account className={styles.cellIcon} />}
      &nbsp;
      {formatNumber(row.original.entrants)}
    </>
  );

  return <TableCellBase {...props} displayValue={displayValue} />;
});

export default TableCellPlayers;
